import { FiltrerAction, SearchCustomerQueryObjectTypes } from './types'
import { UPDATE_APP_ID, UPDATE_OU_NAME, UPDATE_QUERY } from './actions'

const initialState: SearchCustomerQueryObjectTypes = {
  Query: '',
  OuName: '',
  AppId: '',
  ModuleID: '',
  ActivationStatus: '',
  EcommerceStatus: '',
  SalesRep: ''
}

export function customerQueryReducer(
  state: SearchCustomerQueryObjectTypes = initialState,
  FiltrerAction: FiltrerAction
): SearchCustomerQueryObjectTypes {
  switch (FiltrerAction.type) {
    case UPDATE_QUERY:
      return { ...state, Query: FiltrerAction.payload }
    case UPDATE_APP_ID:
      return { ...state, AppId: FiltrerAction.payload }
    case UPDATE_OU_NAME:
      return { ...state, OuName: FiltrerAction.payload }
    default:
      return state
  }
}
